// @flow
import React, { Component } from "react"
import ReactModal from "react-modal"
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { formatTime } from "../lib/TickUtils"
import _ from "lodash"

@observer
export default class MapLibrary extends Component {

    @observable filteredMaps;

    search: Object

    constructor(props) {
        super(props)
        this.updateFilteredMaps()
    }

    updateFilteredMaps = (newMaps) => {
        const maps = newMaps || this.props.maps
        this.filteredMaps = (
            this.search && this.search.value
                ? maps.filter(m => m.name.match(new RegExp(this.search.value, "i")))
                : maps
        )
    }

    componentWillReceiveProps(nextProps) {
        this.updateFilteredMaps(nextProps.maps)
    }

    render() {
        const { hideMapLibrary, visible, maps, selectMap, currentMap } = this.props
        return (
            <ReactModal
                isOpen={visible}
                contentLabel="Map Library"
                onRequestClose={hideMapLibrary} >

                <div className="row">
                    <div className="col-md-6">
                        <h3>Map Library</h3>
                    </div> 
                    <div className="col-md-6">
                        <h3 style={{textAlign: "right"}}> 
                            <a href="#" onClick={hideMapLibrary}>
                                [CLOSE]
                            </a>
                        </h3>
                    </div> 
                </div>

                <input
                    ref={(input) => this.search = input}
                    onChange={this.updateFilteredMaps}
                    style={{ marginBottom: 20 }}
                    type="text"
                    className="form-control"
                    placeholder="Search maps..."
                />
                <table className="mapSelection table table-striped table-inverse table-hover">
                    <tbody>
                        {
                            _.sortBy(this.filteredMaps, (item) => item.name).map(map => 
                                <tr key={map.id} onClick={() => selectMap(map)} className={ currentMap === map && "selected"}>
                                    <td>
                                        { map.locked && <i className="fa fa-lock" style={{ marginRight: 10 }}/> }
                                        { map.name }
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </ReactModal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/MapLibrary.js